import axios from "axios";
import KeyCloakService from "../security/KeycloakService";
import UnlockValidationModalStore from "@/stores/unlockValidationModalStore";

const HttpMethods = {
    GET: "GET",
    POST: "POST",
    DELETE: "DELETE",
};

const _axios = axios.create();

// Versão do bundle injetada pelo Vite (`define` em vite.config.js); em `npm run dev` sem
// version.js ela vale 'desenvolvimento'.
const versaoDoFrontend = typeof __APP_VERSION__ === "string" ? __APP_VERSION__ : "desconhecida";

const configureAxiosKeycloak = () => {
    /* Requests */
    // O interceptor é assíncrono de propósito: `UpdateToken` devolve Promise e o header só pode
    // ser montado DEPOIS do refresh resolver. Sem o await, na virada de expiração a requisição
    // saía com o token velho e tomava 401 — o refresh resolvia tarde demais.
    // Requisições concorrentes não geram um refresh cada: o keycloak-js enfileira as chamadas
    // simultâneas a updateToken() e todas aguardam a mesma ida ao servidor.
    _axios.interceptors.request.use(
        async (config) => {
            // Vai em toda requisição, autenticada ou não, para a API saber qual versão do
            // front a chamou.
            config.headers["Frontend-Version"] = versaoDoFrontend;

            if (KeyCloakService.IsLoggedIn()) {
                await KeyCloakService.UpdateToken();

                config.headers.Authorization = `Bearer ${KeyCloakService.GetAccesToken()}`;
            }

            return config;
        }
    );

    // Interceptor de Requisição
    // _axios.interceptors.request.use(
    //     (config) => {
    //         // Recupera o token de liberação do coordenador
    //         const tokenAprovacao = localStorage.getItem('token_aprovacao');

    //         // Se o token existir, adiciona o header customizado
    //         if (tokenAprovacao) {
    //             config.headers['X-Supervisor-Token'] = tokenAprovacao;
    //             console.log("Token foi adicionado no header customizado")
    //         }

    //         return config;
    //     },
    //     (error) => {
    //         return Promise.reject(error);
    //     }
    // );

    /* Responses */
    _axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error?.response?.status === 423) {
                const pId = error.response?.data?.processoId ?? null;
                UnlockValidationModalStore.open(pId);
            }
            return Promise.reject(error);
        }
    );

    // _axios.interceptors.response.use(
    //     (response) => {
    //         // Só limpa o token se a requisição de origem utilizou o header de aprovação
    //         if (response.config.headers && response.config.headers['X-Supervisor-Token']) {
    //             localStorage.removeItem('token_aprovacao');
    //             console.log("Token foi removido do localstorage")
    //         }
    //         return response;
    //     },
    //     (error) => {
    //         // Faz o mesmo tratamento para cenários de erro
    //         if (error.config && error.config.headers && error.config.headers['X-Supervisor-Token']) {
    //             localStorage.removeItem('token_aprovacao');
    //             console.log("Token foi removido do localstorage")
    //         }
    //         return Promise.reject(error);
    //     }
    // );
};

const getAxiosClient = () => _axios;

const HttpService = {
    HttpMethods,
    configureAxiosKeycloak,
    getAxiosClient,
};

export default HttpService;